import $ from 'jquery';
import ScrollToElement from 'lib/scrollToElement';
import 'theme/moydom/less/pages/faq.less';
import 'theme/moydom/less/pages/rules.less';

function openScrollToTarget(scrollTo) {
    const target = scrollTo.getTarget();

    if (target) {
        target.find('a.collapsed').trigger('click');
    }
}

$(() => {
    const firstScroll = new ScrollToElement();

    firstScroll.setDuration(0).setOvermeasure(-50).byHash();

    openScrollToTarget(firstScroll);

    $('.js-scrollTo').each((i, e) => {
        const scrollTo = new ScrollToElement(
            {},
            {
                scroll: () => {
                    openScrollToTarget(scrollTo);
                },
            }
        );

        scrollTo.setOvermeasure(-50).init($(e));
    });
});
